/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type FilterGroup,
    FilterGroupFromJSON,
    FilterGroupToJSON,
} from '../models/FilterGroup';
import {
    type FilterItemDetail,
    FilterItemDetailFromJSON,
    FilterItemDetailToJSON,
} from '../models/FilterItemDetail';
import {
    type PaginatedFilterGroupList,
    PaginatedFilterGroupListFromJSON,
    PaginatedFilterGroupListToJSON,
} from '../models/PaginatedFilterGroupList';
import {
    type PaginatedFilterItemList,
    PaginatedFilterItemListFromJSON,
    PaginatedFilterItemListToJSON,
} from '../models/PaginatedFilterItemList';

export interface GeodataGroupsListRequest {
    ordering?: string;
    page?: number;
    pageSize?: number;
}

export interface GeodataGroupsRetrieveRequest {
    id: number;
}

export interface GeodataItemsListRequest {
    group?: number;
    page?: number;
    pageSize?: number;
    search?: string;
}

export interface GeodataItemsRetrieveRequest {
    id: number;
}

/**
 * 
 */
export class GeodataApi extends runtime.BaseAPI {

    /**
     * Creates request options for geodataGroupsList without sending the request
     */
    async geodataGroupsListRequestOpts(requestParameters: GeodataGroupsListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/geodata/groups/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve filter groups
     */
    async geodataGroupsListRaw(requestParameters: GeodataGroupsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedFilterGroupList>> {
        const requestOptions = await this.geodataGroupsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedFilterGroupListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve filter groups
     */
    async geodataGroupsList(requestParameters: GeodataGroupsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedFilterGroupList> {
        const response = await this.geodataGroupsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for geodataGroupsRetrieve without sending the request
     */
    async geodataGroupsRetrieveRequestOpts(requestParameters: GeodataGroupsRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling geodataGroupsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/geodata/groups/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve filter groups
     */
    async geodataGroupsRetrieveRaw(requestParameters: GeodataGroupsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FilterGroup>> {
        const requestOptions = await this.geodataGroupsRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FilterGroupFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve filter groups
     */
    async geodataGroupsRetrieve(requestParameters: GeodataGroupsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FilterGroup> {
        const response = await this.geodataGroupsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for geodataItemsList without sending the request
     */
    async geodataItemsListRequestOpts(requestParameters: GeodataItemsListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['group'] != null) {
            queryParameters['group'] = requestParameters['group'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/geodata/items/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve public data point information for the map.
     */
    async geodataItemsListRaw(requestParameters: GeodataItemsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedFilterItemList>> {
        const requestOptions = await this.geodataItemsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedFilterItemListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve public data point information for the map.
     */
    async geodataItemsList(requestParameters: GeodataItemsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedFilterItemList> {
        const response = await this.geodataItemsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for geodataItemsRetrieve without sending the request
     */
    async geodataItemsRetrieveRequestOpts(requestParameters: GeodataItemsRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling geodataItemsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/geodata/items/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve public data point information for the map.
     */
    async geodataItemsRetrieveRaw(requestParameters: GeodataItemsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FilterItemDetail>> {
        const requestOptions = await this.geodataItemsRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FilterItemDetailFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve public data point information for the map.
     */
    async geodataItemsRetrieve(requestParameters: GeodataItemsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FilterItemDetail> {
        const response = await this.geodataItemsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
